import { render, staticRenderFns } from "./GeneralTable.vue?vue&type=template&id=460d9cf8&scoped=true&"
import script from "./GeneralTable.vue?vue&type=script&lang=js&"
export * from "./GeneralTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460d9cf8",
  null
  
)

export default component.exports